module.exports = __webpack_public_path__ + "500bfa6dc3d1b0c165acd668fc2aae66.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-1080.webp
// module id = 339
// module chunks = 0